// Lib
import { classicFormat } from '@/utils/hooks/format/useFormatNumber';

import { SIZE_50 } from '@/lib/gridElements/size';
import { INSTAGRAM } from '@/lib/socialProfile';

// Components
import { SingleIconPieChart } from '@/components/composite/Charts/SingleIconPieChart';

export const mentionsByType = {
    title: 'chart.instagram.mentions_by_type',
    id: 'mentions_distribution_per_type',
    icon: 'comments-on',
    name: {
        caption: 'chart.mentions_type_instagram.caption',
        comment: 'chart.mentions_type_instagram.comment',
        tag: 'chart.mentions_type_instagram.tag',
        type: 'type',
        value: 'count',
        percentage_formatted: 'percentage'
    },
    color: {
        caption: 'purple',
        comment: 'orange',
        tag: 'blue'
    },
    social: INSTAGRAM,
    tooltipTranslation: {
        token: 'chart.facebook.views_distribution_source_tooltip_translation',
        values: ['generic_name', 'value', 'percentage']
    },
    tableColumnFormatterTranslation: 'analytics:chart.instagram.percentage_post',
    valueFormat: classicFormat,
    tooltip: 'chart.instagram.mentions_by_type_tooltip',
    size: SIZE_50,
    type: 'chart',
    element: SingleIconPieChart
};
